import React, {useContext} from 'react';
import {Card, Form, Input, Row, Col, Button, Select} from 'antd';

import TDSelect from 'src/app/components/TDSelect';
import {requestPOST} from 'src/utils/baseAPI';

const FormItem = Form.Item;

const Publisher = ({publish}) => {
  const [form] = Form.useForm();

  // topic, QoS for publishing message
  const record = {
    topic: 'testtopic/react',
    qos: 0,
  };

  const onFinish = () => {
    const formData = form.getFieldsValue(true);
    const topic = (formData?.topicBegin ?? '') + (formData?.hardwaredeviceCode ?? '') + (formData?.topicEnd ?? '');
    formData.topic = topic;

    publish(formData);
  };

  const PublishForm = (
    <Form layout='vertical' name='basic' form={form} initialValues={record} onFinish={onFinish}>
      <div className='row'>
        <div className='col-xl-4 col-lg-4'>
          <FormItem label='Topic Begin' name='topicBegin' rules={[{required: true, message: 'Không được để trống!'}]}>
            <Input placeholder='' />
          </FormItem>
        </div>
        <div className='col-xxl-4 col-xl-3 col-lg-4'>
          <FormItem label='Thiết bị' name='hardwaredevice'>
            <TDSelect
              showSearch={true}
              reload={true}
              placeholder='Thiết bị'
              fetchOptions={async (keyword) => {
                const res = await requestPOST(`api/v1/hardwaredevices/search`, {
                  pageNumber: 1,
                  pageSize: 10000,
                  keyword: keyword,
                });
                return res.data.map((item) => ({
                  ...item,
                  label: `${item.code}`,
                  value: item.code,
                }));
              }}
              style={{
                width: '100%',
              }}
              onChange={(value, current) => {
                if (value) {
                  form.setFieldValue('hardwaredeviceCode', current?.code);
                } else {
                  form.setFieldValue('hardwaredeviceCode', null);
                }
              }}
            />
          </FormItem>
        </div>
        <div className='col-xl-4 col-lg-4'>
          <FormItem label='Topic End' name='topicEnd'>
            <Input placeholder='' />
          </FormItem>
        </div>
        <div className='col-xl-12 col-lg-12'>
          <FormItem label='QoS' name='qos' rules={[{required: true, message: 'Không được để trống!'}]}>
            <Select
              options={[
                {
                  label: '0',
                  value: 0,
                },
                {
                  label: '1',
                  value: 1,
                },
                {
                  label: '2',
                  value: 2,
                },
              ]}
            />
          </FormItem>
        </div>
        <div className='col-xl-12 col-lg-12'>
          <Form.Item label='Payload' name='payload'>
            <Input.TextArea />
          </Form.Item>
        </div>
        <Col span={8} offset={16} style={{textAlign: 'right'}}>
          <Form.Item>
            <Button type='primary' htmlType='submit'>
              Publish
            </Button>
          </Form.Item>
        </Col>
      </div>
    </Form>
  );

  return <Card title='Publisher'>{PublishForm}</Card>;
};

export default Publisher;
